import { ReactNode, useRef, useEffect } from "react";

type DropdownModelProps = {
  children: ReactNode;
  isOpen: boolean;
  handleClose: (action : boolean) => void;
  modalStyle?:string
};

export default function DropDownModel({
  children,
  isOpen,
  handleClose,
  modalStyle
}: DropdownModelProps) {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const handleClickOutside = (event: MouseEvent) => {
    // Check if the click target is a button or has a button parent
    const target = event.target as HTMLElement;
    const isButton = target.tagName === 'BUTTON' || target.closest('button');
    
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node) && !isButton) {
      handleClose(false); // Close the dropdown when clicking outside and not on a button
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]); // Re-run the effect when isOpen changes

  return <div ref={dropdownRef} className={`relative ${modalStyle}`}>{children}</div>;
}
